import theme from "@ch/helpers/utils/theme";
import type { CSSProperties, FC } from "react";

export interface ProgressBarProps {
  /** Progress value (0–100). */
  progress?: number;
  backgroundColor?: string;
  progressColor?: string;
  height?: number;
  borderRadius?: number;
  className?: string;
  style?: CSSProperties;
  testId?: string;
  accessibilityLabel?: string;
}

const ProgressBar: FC<ProgressBarProps> = ({
  progress = 0,
  backgroundColor = "#E6E9EC",
  progressColor = theme.colors.green.DEFAULT,
  height = 8,
  borderRadius = 4,
  className = "",
  style,
  testId,
  accessibilityLabel,
}) => {
  const clampedProgress = Math.max(0, Math.min(100, progress));
  const roundedProgress = Math.round(clampedProgress);

  return (
    <div
      aria-label={accessibilityLabel}
      aria-valuemax={100}
      aria-valuemin={0}
      aria-valuenow={roundedProgress}
      className={className}
      data-testid={testId}
      role="progressbar"
      style={{
        height,
        backgroundColor,
        borderRadius,
        width: "100%",
        overflow: "hidden",
        ...style,
      }}
    >
      <div
        style={{
          width: `${clampedProgress}%`,
          height: "100%",
          backgroundColor: progressColor,
          borderRadius,
          transition: "width 0.2s ease-out",
        }}
      />
    </div>
  );
};

export default ProgressBar;
